import OverlayBox from "../../OverlayBox.js";
import Button from "../../Button.js";
import ObjectTranslation from "../../../objects/ObjectTranslation.js";
import Persons from "../../../objects/Persons.js";
import EditPersonsOverlay from "./EditPersonsOverlay.js";
import Observable from "../../../misc/Observable.js";
import PersonsDetailTable from "./PersonsDetailTable.js";

class ShowPersonsOverlay extends Observable {
	constructor(config) {
		super(config);
		if (config) {
			this.persons = config.persons;
		}
		let scope = this;
		this.overlayBox = new OverlayBox({
			isCloseable: true
		});
		ObjectTranslation.getObjectNameTranslation(Persons.OBJECT_DESCRIPTION_ID, function(objectNameTranslation){
			scope.overlayBox.getHeader().text(objectNameTranslation.name);
			}
		);
		let editButton = Button.createEditButton();
		this.overlayBox.getFooter().append(editButton);
		editButton.click(function() {
			scope.overlayBox.remove();
			new EditPersonsOverlay({
				persons: scope.persons,
				eventCallback:function(event){scope.notify(event)}
			});
		});
		
		let detailTable = new PersonsDetailTable({
			persons: this.persons
		});
		this.overlayBox.append(detailTable);
	}
}
export default ShowPersonsOverlay;